import { COMPANY_AS_SELECTION, CompanyOnlineModel } from "./types";
import {
  BasicAccountApplicationDocument,
  CompanyOnlineDto,
  NaturalPersonDocument,
  NaturalPersonDto,
} from "../../api/commercial/generated-types";

const mapDocumentToPageModel = (
  document: BasicAccountApplicationDocument,
): CompanyOnlineModel => {
  let authorizedRepresentatives: BasicAccountApplicationDocument["powerOfAttorneys"] =
    [];
  const isAdminPowerOfAttorney: boolean = document.adminIsPowerOfAttorney;
  if (isAdminPowerOfAttorney) {
    authorizedRepresentatives.push(document.admin);
  }
  if (document.powerOfAttorneys.length > 0) {
    authorizedRepresentatives = authorizedRepresentatives.concat(
      document.powerOfAttorneys,
    );
  }
  let selectedStatementRecipient: string = COMPANY_AS_SELECTION;
  let selectedCardsAndPinRecipient: string = COMPANY_AS_SELECTION;
  authorizedRepresentatives.forEach(
    (authorizedRepresentative: NaturalPersonDocument): void => {
      if (authorizedRepresentative.isStatementRecipient) {
        selectedStatementRecipient = authorizedRepresentative.emailBusiness;
      }
      if (authorizedRepresentative.isCardsOrPinRecipient) {
        selectedCardsAndPinRecipient = authorizedRepresentative.emailBusiness;
      }
    },
  );

  return {
    authorizedRepresentatives,
    companyName: document.company.name,
    selectedStatementRecipient,
    selectedCardsAndPinRecipient,
    companyOnlineSecurityCode: document.companyOnlineSecurityCode,
    acceptMarketingEmails: document.acceptMarketingEmails,
  };
};

const mapPageModelToRequest = (
  data: CompanyOnlineModel,
  basicAccountApplicationRef: string,
): CompanyOnlineDto => {
  const authorizedRepresentatives: NaturalPersonDto[] =
    data.authorizedRepresentatives.map(
      (authorizedRepresentative: NaturalPersonDocument): NaturalPersonDto => {
        if (
          data.selectedStatementRecipient === COMPANY_AS_SELECTION ||
          data.selectedStatementRecipient !==
            authorizedRepresentative.emailBusiness
        ) {
          authorizedRepresentative.isStatementRecipient = false;
        }
        if (
          data.selectedStatementRecipient ===
          authorizedRepresentative.emailBusiness
        ) {
          authorizedRepresentative.isStatementRecipient = true;
        }
        if (
          data.selectedCardsAndPinRecipient === COMPANY_AS_SELECTION ||
          data.selectedCardsAndPinRecipient !==
            authorizedRepresentative.emailBusiness
        ) {
          authorizedRepresentative.isCardsOrPinRecipient = false;
        }
        if (
          data.selectedCardsAndPinRecipient ===
          authorizedRepresentative.emailBusiness
        ) {
          authorizedRepresentative.isCardsOrPinRecipient = true;
        }

        return {
          email: authorizedRepresentative.emailBusiness,
          isCompanyOnlineAdmin: authorizedRepresentative.isCompanyOnlineAdmin,
          isCardsOrPinRecipient: authorizedRepresentative.isCardsOrPinRecipient,
          isStatementRecipient: authorizedRepresentative.isStatementRecipient,
        };
      },
    );

  const companyOnlineSecurityCode: string =
    authorizedRepresentatives.length === 0
      ? null
      : data.companyOnlineSecurityCode;

  return {
    basicAccountApplicationRef,
    authorizedRepresentatives,
    companyOnlineSecurityCode,
    acceptMarketingEmails: data.acceptMarketingEmails,
  };
};

export const CompanyOnlineMapper = {
  mapPageModelToRequest,
  mapDocumentToPageModel,
};
